import { render, staticRenderFns } from "./ConsoleStatistics.vue?vue&type=template&id=096f4022&scoped=true&"
import script from "./ConsoleStatistics.vue?vue&type=script&lang=js&"
export * from "./ConsoleStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleStatistics.vue?vue&type=style&index=0&id=096f4022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f4022",
  null
  
)

export default component.exports